export function ymGoal(code: number, name: string) {
  // @ts-ignore
  ym(code, 'reachGoal', 'barLinkClick')
}
